import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@spothero/ui-backlog';
import {Box} from '@spothero/ui';
import CancellationInfo from 'common/cancellation-info';
import Price from 'common/price';
import AvailableInventory from '../available-inventory-message';

const AirportPurchaseSnapshot = ({
    cancellationAllowed,
    displayPrice,
    currencyType,
    availableTransientInventory,
    checkoutDisabled,
    onCheckoutClick,
}) => {
    return (
        <div className="AirportPurchaseSnapshot">
            <Box
                height={8}
                paddingX={4}
                paddingY={2}
                borderBottomWidth="1px"
                borderColor="gray.200"
            >
                <CancellationInfo
                    cancellationAllowed={cancellationAllowed}
                    showFreeCancellation
                />
            </Box>
            <div className="AirportPurchaseSnapshot-price-container">
                <div className="AirportPurchaseSnapshot-price-inventory">
                    <div className="AirportPurchaseSnapshot-price">
                        <Price
                            amount={displayPrice}
                            currencyType={currencyType}
                        />
                        <span>/day</span>
                    </div>
                    <AvailableInventory
                        availableTransientInventory={
                            availableTransientInventory
                        }
                    />
                </div>

                <Button
                    color="primary"
                    disabled={checkoutDisabled}
                    onClick={onCheckoutClick}
                >
                    Book Now
                </Button>
            </div>
        </div>
    );
};

AirportPurchaseSnapshot.propTypes = {
    cancellationAllowed: PropTypes.string.isRequired,
    displayPrice: PropTypes.number.isRequired,
    currencyType: PropTypes.string.isRequired,
    availableTransientInventory: PropTypes.number.isRequired,
    checkoutDisabled: PropTypes.bool.isRequired,
    onCheckoutClick: PropTypes.func.isRequired,
};

export default AirportPurchaseSnapshot;
